export default "__VITE_ASSET__UvTcPUsM__"